var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlowers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line-supplement"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m37.1939,66.4663c-2.3761-12.0905-6.2225-23.8449-11.4534-35.0012"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m35.6613,30.4548s4.1766,21.6262-2.0021,33.0812"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m46.7181,30.4548s-5.3346,22.94-14.5865,35.2644"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.1049,
    d: "m31.9765,54.9543s-3.0829,2.95,5.9207,4.0468c6.4239.7826,4.5685-2.8057,4.5685-2.8057"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5c9e31",
    d: "m34.6845,65.5361c-1.1046-.0009-1.9993-.897-1.9984-2.0016.0003-.3308.0826-.6564.2396-.9476,6.4991-11.421,1.1687-35.079,1.1287-35.288-.2093-1.0846.5003-2.1335,1.5849-2.3428,1.0846-.2093,2.1335.5003,2.3428,1.585.1758.9111,4.9085,25.9989-1.5349,37.9443-.3494.6479-1.0265,1.0516-1.7627,1.0507Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b1cc33",
    d: "m31.8326,67.7258c.4501.2763,1.0371.1597,1.3474-.2678,9.1227-12.83,15.7884-39.4851,16.0058-40.42.2502-1.076-.4192-2.1511-1.4951-2.4014-1.076-.2502-2.1511.4192-2.4014,1.4951-.0506.22-5.8561,26.6265-15.47,38.9794-.3301.442-.2394,1.0679.2026,1.3981.03.0224.0612.0431.0934.0619l1.7173,1.1546Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b1cc33",
    d: "m39.1973,67.0755c.5159-.1015.8519-.6021.7504-1.118-.0016-.0081-.0033-.0162-.0051-.0242-.9945-4.4153-5.5785-23.2177-13.42-40.1127-.4682-1.0036-1.6614-1.4376-2.665-.9693-.0999.0466-.1957.1014-.2866.1637-.8056.5952-1.0725,1.68-.6352,2.5811,3.3473,7.2972,5.4282,11.218,8.1834,19.046,2.8281,8.035,4.2236,16.2031,5.1338,20.092.1198.503.6181.8194,1.1243.7137l1.82-.3723Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b399c8",
    d: "m41.817,27.123s6.0374,3.9174,10.18-1.4008-2.9863-13.0114-2.9863-13.0114c0,0-4.5943-4.6622-7.2593-2.143,0,0,5.4376,9.2578,2.9326,13.2426-2.5035,3.9821-2.867,3.3126-2.867,3.3126Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b399c8",
    d: "m50.0217,27.0109c2.2638,1.8432,5.5933,1.5023,7.4365-.7616.1243-.1527.24-.3122.3465-.4777,3.5786-4.66.33-10.9931.33-10.9931,0,0-1.7291-4.2453-4.2774-4.8885s-5.1918,3.8539-5.1918,3.8539c0,0,6.5567,7.2942,1.3562,13.267Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8967aa",
    d: "m49.215,12.9152s-2.5449-2.6213-5-3.0472c.3986-1.6425,1.2936-3.1223,2.5633-4.238.7375-.2984,1.5751-.2108,2.235.2337.9242.7443,1.7382,1.6159,2.4176,2.5888l.754,1.6058c-1.1979.7094-2.2146,1.6874-2.9699,2.8569Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa7c0",
    d: "m27.3162,23.81c-2.505-3.9848,2.9326-13.2426,2.9326-13.2426-2.665-2.5192-7.2593,2.143-7.2593,2.143,0,0-7.1287,7.6932-2.9863,13.0114s10.18,1.4008,10.18,1.4008c0,0-.3632.6699-2.867-3.3126Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffa7c0",
    d: "m23.3345,13.7439s-2.6435-4.4971-5.1918-3.8539-4.2776,4.8885-4.2776,4.8885c0,0-3.2484,6.3332.33,10.9931,1.5794,2.4552,4.8501,3.1652,7.3053,1.5858.1656-.1065.3251-.2222.4777-.3465-5.2003-5.9728,1.3564-13.267,1.3564-13.267Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e67a94",
    d: "m19.8151,10.0583l.754-1.6058c.6794-.9729,1.4934-1.8445,2.4176-2.5888.6599-.4445,1.4975-.5321,2.235-.2337,1.2698,1.1156,2.1649,2.5954,2.5635,4.238-2.4553.4259-5,3.0472-5,3.0472-.7554-1.1695-1.7722-2.1475-2.9701-2.8569Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4aa41",
    d: "m35.8811,13.2113c-1.6425,1.518-3.6864,5.5415-3.771,7.1322-.1445,2.7169-.0536,3.3326,1.4953,5.9309.1783.2991.36.2716.9114.7035.7524.5892-2.82,1.282-2.82,1.282-2.2728.1605-3.7376-2.3027-4.578-4.4424-2.0163-5.1337,2.516-13.92,4.7889-14.08,0,0,1.2362.1488,4.3213,3.0765l-.3479.3973Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4aa41",
    d: "m40.5968,11.977c1.9846.5944,5.4435,8.6057,2.6394,12.71-.8333,1.2701-2.206,2.0846-3.72,2.2074-.9095.1197-1.8336.0597-2.72-.1767h0c-2.0287-.42-3.39-2.5163-3.6055-4.5768-.5172-4.9436,5.3776-10.5838,7.4062-10.1638"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e27022",
    d: "m33.95,9.7953c1.0766-1.7282,2.5759-2.9937,3.3718-2.9022"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e27022",
    d: "m35.9062,13.8005s-3.181-2.7028-3.3862-2.7905c-.25-.1074.6713-3.36,3.7143-5.2035s5.1841,5.1835,5.1841,5.1835l-1.5056.2149c-.243.0339-.4753.1217-.68.2569-.9222.6096-3.3266,2.3387-3.3266,2.3387Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m37.1939,66.4663c-2.3761-12.0905-6.2225-23.8449-11.4534-35.0012"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m35.6613,30.4548s4.1766,21.6262-2.0021,33.0812"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m45.2181,30.4548c-.903,3.1511-7.6981,28.0865-13.0865,35.2644"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fcea2b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.1049,
    d: "m31.9765,54.9543s-3.0829,2.95,5.9207,4.0468c6.4239.7826,4.5685-2.8057,4.5685-2.8057"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m40.6573,11.1693c2.1643.6482,5.9363,9.3848,2.8784,13.8606-.9087,1.3851-2.4057,2.2733-4.0568,2.4072-.9919.1306-1.9998.0651-2.9664-.1927h0c-2.2123-.458-3.6969-2.7441-3.9319-4.9911-.5641-5.3912,5.8643-11.542,8.0767-11.084"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m34.4076,8.9219c.9368-1.5038,2.2414-2.6049,2.9339-2.5253"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m37.3415,6.3966c.5485.1119,1.3515,1.09,1.9495,2.3752"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m31.3693,27.29c-2.2541.1518-3.801-1.669-4.63-3.7707-1.9886-5.0427,2.5558-12.6916,4.81-12.8434"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m31.3726,10.6634c.8649.1602,1.65.6086,2.2274,1.2722"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m46.0133,27.4921c.8108.0431,1.6233-.0405,2.4083-.2476h0c2.2123-.458,3.6969-2.7441,3.9319-4.9911.477-4.559-4.0464-9.6612-6.7921-10.8508"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m50.5265,8.9219c-.9365-1.5038-2.2414-2.6049-2.9339-2.5253"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m47.5926,6.3966c-.5485.1119-1.3515,1.09-1.95,2.3752"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m53.5648,27.29c2.2541.1518,3.801-1.669,4.63-3.7707,1.9886-5.0427-2.5558-12.6916-4.81-12.8434"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m53.5615,10.6634c-.8649.1602-1.65.6086-2.2274,1.2722"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m26.4386,11.4026c-2.7457,1.19-7.2691,6.2918-6.7921,10.8508.235,2.247,1.72,4.5331,3.9319,4.9911h0c.785.2071,1.5975.2907,2.4083.2476"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m24.4074,6.3966c-.6925-.08-1.9971,1.0215-2.9339,2.5253"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m26.3569,8.7718c-.598-1.2856-1.401-2.2633-1.95-2.3752"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m18.6154,10.676c-2.2542.1518-6.7986,7.8007-4.81,12.8434.8288,2.1017,2.3757,3.9225,4.63,3.7707"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m20.6659,11.9356c-.5774-.6636-1.3625-1.112-2.2274-1.2722"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowers);
export default __webpack_public_path__ + "static/media/flowers.07c20f3ebcb693176a6e34ecc757b724.svg";
export { ForwardRef as ReactComponent };